/**
 * Simple wrapper around the HTML5 FileReader object to turn its API into a promise based interface.
 * This doesn't expose all the functionality of the API (such as progress notifications etc, so should only be
 * used in simple situations.
 */
const readFile = (method) => (file, bytes) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (onloadEvent) => resolve(onloadEvent.target.result);
        reader.onabort = (onabortEvent) => reject(onabortEvent);
        reader.onerror = (onerrorEvent) => reject(onerrorEvent);

        // TODO FLickr used webkit & mozilla fallbacks here, double check if this is necessary
        const filePortion = bytes ? file.slice(0, bytes) : file;
        reader[method](filePortion);
    });

// Methods to place into the file reader
export const readAsDataURL = readFile('readAsDataURL');
export const readAsArrayBuffer = readFile('readAsArrayBuffer');
// Not supported in IE
export const readAsBinaryString = readFile('readAsBinaryString');
